import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DevPermission, IPermission } from './types';
import {
  IUserPermissionFieldsFragment,
  IUserSetting,
} from '../../../utils/apollo/graphqlSchema';

const initialState: IPermission = {
  devPermission: DevPermission.Default,
  roles: [],
  user: null,
};

/**
 * This slice contains the user's permission information and the dev permission.
 * The dev permission is used to overwrite the visibility of the permission controls in local/int/ux environments.
 * The user's permission is used to control the permissions in all environments and update in Layout.tsx from Kobol.
 */
const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    setDevPermission: (
      draft,
      action: PayloadAction<{ devPermission: DevPermission }>,
    ) => {
      draft.devPermission = action.payload.devPermission;
    },
    setUser: (
      draft,
      action: PayloadAction<{
        roles: IPermission['roles'];
        user: IUserPermissionFieldsFragment;
      }>,
    ) => {
      draft.user = action.payload.user;
      draft.roles = action.payload.roles;
    },
    updateUserFields: (
      draft,
      action: PayloadAction<{
        user: IUserPermissionFieldsFragment;
      }>,
    ) => {
      draft.user = action.payload.user;
    },
    updateDefaultSchemaSetting: (
      draft,
      action: PayloadAction<{ defaultSchemaSetting: IUserSetting }>,
    ) => {
      const { defaultSchemaSetting } = action.payload;
      if (draft.user) {
        draft.user.defaultSchemaSetting = defaultSchemaSetting;
      }
    },
  },
});

export default permissionSlice;
